import styles from "./EmailSubHeader.module.css";

const EmailSubHeader = () => {
  return  <span className={styles.headerSubTitle}>We have sent you an email to confirm your warranty registration</span>
} 
export default EmailSubHeader;